import { delegate } from "tippy.js";

delegate("body", {
  target: "button.btn-tooltip",
  trigger: "click",
  interactive: true,
  theme: "light-border",
  maxWidth: 800,
  arrow: true,
  allowHTML: true,
  content(triggerEl) {
    const templateSelector = triggerEl.dataset.tippyTemplate;
    const template = document.querySelector(templateSelector);
    return template?.innerHTML;
  },
});
